<template>
  <div class="Home">
    <SideBar></SideBar>

    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>平台优势</h3>
          <i class="selected"></i>
          <div class="_text">基于实际商用解决方案，提供与产业接轨的教育产品</div>
          <div class="personnel">
            <div class="personnel_img">
              <div></div>
            </div>
            <p class="personnel_text">
              基于物联网行业的需求与痛点，华为提出“1+2+1”的物联网解决方案，<br />定位于平台的搭建者、连接的创新者、生态的推动者。
            </p>
          </div>
        </div>
        <!-- 平台资源 -->
        <div class="conent_box resources">
          <h3>产品资源</h3>
          <i class="selected"></i>
          <div class="_text">
            融合华为“1+2+1"产品解决方案，打造符合产业需求与教学实际的教育产品
          </div>
          <div class="_text1">
            浙江华为物联网实训室包含NB-IoT物联网全栈实验箱、物联网多网融合通信实验箱、物联网与5G场景实训套件、鸿蒙通用实训套件、浙江华为物联网综合实训平台、物联网掌上实验实训平台。学生可基于NB-IoT物联网全栈实验箱及配套环境，掌握物联网端到端的全栈技术业务流程；基于物联网多网融合通信实验箱及配套环境，掌握不同场景下物联网通信技术的应用；基于物联网与5G场景实训套件及配套环境，掌握物联网行业化场景应用；基于鸿蒙通用实训套件及配套环境，掌握物联网应用开发技术及设备开发技术。
          </div>
          <!-- 环境 -->
          <div class="surroundings">
            <ul class="application">
              <li v-for="(item, index) in picList" :key="index">
                <div class="application_title">
                  {{ item.title }}
                </div>
                <div class="application_img">
                  <!-- <pic-zoom
                    :url="item.img"
                    :bigWidth="150"
                    :scale="3"
                    overlayStyle=" width:100%;height: 100%;border-radius: 3px;"
                  ></pic-zoom> -->
                  <img :src="item.img" alt="" />
                </div>
                <div class="application_text">
                  <h4>{{ item.text1 }}</h4>
                  <p v-for="item1 in item.chren" :key="item1">
                    {{ item1 }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 平台支撑 -->
        <div class="conent_box support">
          <h3>实训室架构拓扑</h3>
          <i class="selected"></i>
          <ul class="support_box">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Experiment extends Vue {
  picList= [
        {
          title: "浙江华为物联网综合实训平台",
          text1: "丰富教学资源，满足多重能力开发",
          chren: [
            "提供丰富的精品课程资源与实验材料",
            "物联网中间件在线实验环境",
            "支持底层开发实验现象验证",
            "满足教学、实验、开发多重需求",
            "帮助用户快速构建物联网能力",
          ],

          img: require("@/zh-website/src/assets/network5.png"),
        },
        {
          title: "浙江华为物联网掌上实验实训平台",
          text1: "“移动”实训平台，助力碎片化学习",
          chren: [
            "基于微信开发的轻量级物联网APP",
            "满足物联网场景验证实验",
            "实现物联网端到端完整业务流",
          ],
          img: require("@/zh-website/src/assets/network6.png"),
        },
        {
          title: "物联网多网全模块通信实验箱",
          text1: "助力掌握通信选型与功能实现",
          chren: [
            "基于华为物联网解决方案与实际物联网行业通信需求",
            "助力用户了解物联网通信技术",
          ],
          img: require("@/zh-website/src/assets/network9.png"),
        },
        {
          title: "物联网5G场景实训套件",
          text1: "助力场景化综合应用实训",
          chren: [
            "基于华为物联网解决方案与实际行业需求",
            "助力用户了解物联网与5G通信技术综合化应用",
          ],
          img: require("@/zh-website/src/assets/network7.png"),
        },
        {
          title: "NB-IoT全栈实验实训箱",
          text1: "助力提升开发能力",
          chren: [
            "基于华为物联网解决方案与实际行业需求",
            "结合目前物联网主流行业",
            "助力用户了解物联网终端功能实现",
          ],
          img: require("@/zh-website/src/assets/network8.png"),
        },
        {
          title: "鸿蒙通用实训套件",
          text1: "助力提升应用开发及设备开发能力",
          chren: ["基于华为物联网与鸿蒙解决方案", "助力用户了解物联网开发技术"],
          img: require("@/zh-website/src/assets/network11.png"),
        },
      ]
      // 背景图样式文案
      list={
        style: {
          "background-image": `url(${require("@/zh-website/src/assets/banner_certification.png")})`,
          height: "493px",
        },
        font1: "人工智能专业建设",
        font2: "",
        font3: "",
        font4: "全场景、端到端",
        font5: "培养智能时代智慧人才",
        button: "",
      }
}

</script>
<style lang="less" scoped>
p {
  padding-top: 10px;
}

// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
  max-width: 1366px;
  margin: 0 auto;
}
.conent_box {
  background-color: #f8f8f8;
  padding: 2.8125rem 0 0;
  margin-bottom: 1.25rem;
  h3 {
    font-size: 1.75rem;
    text-align: center;
    color: #333;
  }
  .selected {
    display: block;
    width: 1.5625rem;
    height: 0.1875rem;
    background-color: #333333;
    margin: 0.625rem auto 0;
  }
  ._text {
    width: 100%;
    text-align: center;
    color: #999999;
    margin: 1.25rem auto 1.875rem;
  }
  // 平台优势
  .personnel {
    .personnel_img {
      width: 100%;
      div {
        height: 435px;
        width: 100%;
        margin: 0 auto;
        background: url(../../../../assets/network3.jpg) no-repeat center center;
        background-size: contain;
        // box-shadow: 0px 0px 20px #ccc;
      }
    }
    .personnel_text {
      color: #999;
      text-align: center;
      padding: 32px 280px 40px;
    }
  }
}
// 平台资源
.resources {
  padding: 2.8125rem 5.625rem 0;
  // 课程
  .course {
    margin-top: 5rem;
    display: flex;
    .course_box {
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      flex: 1;
      font-size: 1.5rem;
      h3 {
        text-align: left;
        font-size: 1.5rem;
        font-weight: 700;
      }
      p {
        font-size: 1.125rem;
        color: #999;
        padding-top: 10px;
      }
      .form_box {
        li {
          padding-top: 1.25rem;
          font-size: 1.125rem;
          div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            i {
              display: inline-block;
              width: 0.1875rem;
              height: 0.1875rem;
              background-color: #dd0011;
              border-radius: 50%;
              margin-top: 22px;
            }
            p {
              width: 98%;
              color: #333;
            }
          }
        }
      }
    }
    .course_img {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      position: relative;
      .pink {
        width: 30rem;
        height: 24.0625rem;
        background-color: pink;
      }
      img {
        position: absolute;
        top: 2.5rem;
        right: 2.5rem;
        width: 30rem;
        height: 24.0625rem;
      }
    }
  }
  ._text {
    width: 100%;
    text-align: center;
    color: #999999;
    margin: 1.25rem auto 1.875rem;
  }
  ._text1 {
    text-align: center;
  }
  // 环境
  .surroundings {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 1.5rem;
    h3 {
      text-align: left;
      font-size: 1.5rem;
      font-weight: 700;
    }
    p {
      font-size: 1.125rem;
      font-weight: 700;
      color: #dd0011;
    }
    .application {
      font-size: 1rem;
      color: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 360px;
        display: flex;
        flex-direction: column;
        margin: 1.875rem 0;
        .application_title {
          width: 100%;
          height: 94px;
          background-image: url("../../../../assets/application.png");
          font-size: 20px;
          text-align: center;
          line-height: 94px;
          border-radius: 5px;
        }
        .application_img {
          width: 360px;
          height: 252px;
          border-radius: 10px;
          overflow: hidden;
          img {
            border-radius: 10px;
            width: 100%;
            height: 100%;
          }
          margin: 15px auto 27px;
        }
        .application_text {
          // text-align: center;
          h4 {
            font-size: 20px;
            color: #333;
          }
          p {
            font-size: 14px;
            color: #666;
            font-weight: 400;
          }
        }
      }
    }
  }
  // 开发工具
  .open {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 15.8125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0.3125rem;
      box-shadow: 0 0 3px 1px #ccc;
      padding: 1.75rem 0;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          // height: 100%;
          margin: 0 auto;
        }
      }
      p {
        font-size: 1.125rem;
        text-align: center;
        color: #333333;
        font-weight: 700;
        // padding-top: 1.25rem;
      }
    }
  }
  // 开发工具介绍
  .introduction {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      height: 12.5rem;
      display: flex;
      flex-direction: column;
      padding-top: 1.875rem;
      h4 {
        font-size: 1.5rem;
        margin: 0;
      }
      p {
        font-size: 0.875rem;
        color: #333333;
        padding-top: 1.125rem;
      }
    }
  }
  // 主流网站
  .website {
    font-size: 1.125rem;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    .website_head {
      color: #dd0011;
    }
    .website_box {
      display: flex;
      flex-wrap: wrap;
      padding: 1.5625rem 0 1.25rem;
      .web {
        .website_box_git {
          width: 13rem;
          height: 7.3125rem;
          background-color: #fff;
          margin-right: 1.25rem;
          border-radius: 0.3125rem;
          img {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        p {
          text-align: center;
          padding: 1.25rem 0 1.875rem;
        }
      }
    }
  }
}
// 平台支撑
.support {
  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }
  .red {
    color: #dd0011;
    font-weight: 600;
  }
  .support_box {
    padding: 44px 0 80px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    li {
      width: 588px;
      height: 466px;
      background-color: #fff;
      &:nth-child(1) {
        background: url(../../../../assets/network11.jpg) no-repeat center center;
        background-size: contain;
      }
      &:nth-child(2) {
        background: url(../../../../assets/network13.jpg) no-repeat center center;
        background-size: contain;
      }
      &:nth-child(3) {
        margin-top: 20px;
        width: 588px;
        background: url(../../../../assets/network12.jpg) no-repeat center center;
        background-size: contain;
      }
    }
  }
  h4 {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .support_h4 {
    margin-top: 50px;
    color: #333;
  }
  .support_p {
    text-align: center;
  }
  .support_img {
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .advantage {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    h5 {
      font-size: 1.25rem;
      font-weight: 600;
      color: #333;
    }
    .advantage_left {
      width: 34.1875rem;
      margin-top: 2.125rem;
      padding-right: 9rem;
      display: flex;
      flex-direction: column;
      text-align: right;
    }
    .advantage_right {
      width: 36.375rem;
      margin-top: 2.125rem;
      padding-left: 11rem;
      display: flex;
      flex-direction: column;
    }
    .advantage_right_1 {
      padding-left: 14rem;
      margin-top: 35px;
    }
    .advantage_left_1 {
      padding-right: 12rem;
      margin-top: 35px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
  .resources .surroundings .application li {
    width: 32%;
  }
  .resources .surroundings .application li .application_img {
    width: 100%;
  }
  // .resources .surroundings .application li .application_img img {
  //   height: 80%;
  // }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  .conent_box {
    padding-top: 10px;
    ._text {
      margin: 10px auto 20px;
    }
    // 平台优势
    .personnel {
      .personnel_text {
        padding: 0;
      }
      .personnel_img {
        div {
          width: 100%;
          height: 433px;
          margin: 0 auto;
          background: url(../../../../assets/p_network3.jpg) no-repeat center center;
          background-size: contain;
        }
        width: 100%;
      }
      // padding: 0;
      // padding-bottom: 10px;
      // flex-direction: column;
      // align-items: center;
      // li {
      //   margin-bottom: 5px;
      // }
    }
  }
  // 平台资源
  .resources {
    padding: 20px 1rem 0;
    // 课程
    .course {
      margin-top: 0;
      flex-direction: column;
      .course_box {
        margin-top: 20px;
        p {
          margin: 0;
        }
        .form_box {
          li {
            padding: 0;
          }
        }
      }
      .course_img {
        margin-top: 0.625rem;
        .pink {
          width: 23rem;
          height: 18rem;
        }
        img {
          width: 23rem;
          height: 18rem;
          top: 1.5rem;
          right: 1.5rem;
        }
      }
    }
    // 环境
    .surroundings {
      margin-top: 20px;
      .application {
        flex-direction: column;
        height: 100%;
        justify-content: start;
        li {
          margin: 0 auto;
          width: 100%;
          height: 100%;
          &:nth-child(2) {
            margin: 0;
          }
          .application_title {
            height: 70px;
            line-height: 70px;
            font-size: 18px;
          }
          .application_img {
            margin-bottom: 10px;
            width: 100%;
            height: auto;
          }
          .application_text {
            margin-bottom: 20px;
            p {
              margin: 0;
              padding-top: 5px;
            }
          }
        }
      }
    }
    // 开发工具
    .open {
      flex-direction: column;
      align-items: center;
      li {
        margin: 0.625rem auto;
        .open_ {
          overflow: hidden;
        }
        // 开发工具介绍
        .introduction {
          height: 100%;
          flex-direction: column;
        }
      }
    }
    // 主流网站
    .website {
      .website_head {
        padding-top: 5px;
      }
      .website_box {
        justify-content: space-between;
        .web {
          width: 49%;

          .website_box_git {
            margin: 0;
            width: 100%;
          }
          p {
            padding: 10px 20px;
          }
        }
      }
    }
  }
  // 平台支撑
  .support {
    .support_box {
      flex-direction: column;
      align-items: center;
      padding: 0 5px;
      li {
        width: 100% !important;
        height: 350px;
      }
    }
    .support_img {
      img {
        opacity: 0;
      }
    }
    .advantage {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .advantage_left {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_right_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_left_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
    }
  }

  .conent_box h3 {
    font-size: 18px;
  }

  .conent_box .personnel .personnel_text {
    font-size: 14px;
    padding: 20px 10px;
  }

  .resources ._text1 {
    font-size: 14px;
  }

  .resources .surroundings .application li .application_text h4 {
    font-size: 18px;
  }

  .conent_box {
    padding-top: 20px;
  }
}
</style>
